module.exports = __webpack_public_path__ + "img/gift4-01-c08-t2.72d99793.png";